// Import all needed functions from channelConfig
import { 
  CHANNELS, 
  getChannelNodes, 
  getNodeInboundRestrictions 
} from '../../lib/channelConfig';

// Node types for workflow structure
export const NODE_TYPES = {
  CHANNEL: 'channel',
  TRIGGER: 'trigger',
  CONDITION: 'condition',
  DELAY: 'delay',
  CUSTOM: 'custom',
  ACTION: 'action'
};

// Helper function to check if two nodes can be connected
export const canConnect = (sourceNode, targetNode) => {
  console.log('Node structures:', {
    sourceNode,
    targetNode
  });

  // Don't allow connection to self
  if (sourceNode.id === targetNode.id) {
    return false;
  }

  const sourceCategory = sourceNode.data?.category;
  const targetCategory = targetNode.data?.category;

  console.log('Categories:', {
    sourceCategory,
    targetCategory
  });

  // Allow trigger to connect to agents
  if (sourceCategory === 'trigger' && targetCategory === 'agent') {
    return true;
  }

  // Allow agents to connect to agents
  if (sourceCategory === 'agent' && targetCategory === 'agent') {
    return true;
  }

  return false;
};

// Helper function to get nodes for a channel
export const getChannelNodesList = (channelType) => {
  const nodes = getChannelNodes(channelType);
  if (!nodes) return [];
  
  return nodes.map(node => ({
    ...node,
    channelType: `${channelType}_${node.id.split('_')[1]}`,
    parentChannel: channelType,
    requiresConnection: node.requiresConnection
  }));
};

// Helper function to check if a node is a specific node type
export const isNodeType = (nodeType) => {
  return nodeType.includes('_');
};

// Helper function to get parent channel type
export const getParentChannelType = (nodeType) => {
  return nodeType.split('_')[0];
};

export const workflowRules = {
  ...CHANNELS,
  // Add any additional workflow-specific rules here
}; 